import { useTabBarContext } from '../../contexts'
import WidgetIcons from '../../utils/icons'
import { ButtonFooter } from './styles'

const TabItem = ({ content, $isMobile }: any) => {
  const { handleChangeTab, active } = useTabBarContext()

  const change = () => {
    handleChangeTab(content.name)
  }

  return (
    <ButtonFooter
      className={active === content.name ? 'active' : ''}
      onClick={content.action || change}
      $isMobile={$isMobile}
      >
      <WidgetIcons
        name={active === content.name ? content.activeIcon : content.icon}
        color="#000" size="20%"
      />
      <label>{content.title}</label>
    </ButtonFooter>
  )
}

export default TabItem
